import { useMemo } from 'react';
import { Pack, RePack, Sample } from 'types';
import { PackState, SampleState } from 'types/enums';

export const useTakenDownSample = (sample: Sample) => {
    const isTakenDown = useMemo(
        () =>
            sample &&
            (sample?.sampleState === SampleState.TakenDown ||
                sample?.pack?.packState === PackState.TakenDown),
        [sample],
    );

    return { isTakenDown };
};

export const useTakenDownPack = (item: Pack | RePack) => {
    const isTakenDown = useMemo(
        () => item && item?.packState === PackState.TakenDown,
        [item],
    );

    return { isTakenDown };
};
